import { render, staticRenderFns } from "./ShowAtividade.vue?vue&type=template&id=5fa29e77"
import script from "./ShowAtividade.vue?vue&type=script&lang=js"
export * from "./ShowAtividade.vue?vue&type=script&lang=js"
import style0 from "./ShowAtividade.vue?vue&type=style&index=0&id=5fa29e77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports